export default "__VITE_ASSET__Dkt$cX4l__"